var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'overflow-hidden': _vm.hidden}},[_c('transition',{attrs:{"name":_vm.transitionName},on:{"leave":_vm.startTransition}},[_c('router-view',{key:_vm.$root.$i18n.locale})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }